import { decodeJwtPayload } from '~/utils/decodeJwtPayload';
export const STALE_JWT_THRESHOLD_SECONDS = 5 * 60;
const decodeJwtTtlSeconds = (jwt)=>{
    const payload = decodeJwtPayload(jwt);
    if (typeof (payload === null || payload === void 0 ? void 0 : payload.exp) !== 'number' || typeof payload.iat !== 'number') {
        return null;
    }
    return payload.exp - payload.iat;
};
export const secondsUntilJwtStale = (jwt, receivedAtMs, nowMs)=>{
    if (jwt == null || receivedAtMs == null) {
        return null;
    }
    const ttlSeconds = decodeJwtTtlSeconds(jwt);
    if (ttlSeconds == null) {
        return null;
    }
    const elapsedSeconds = Math.floor((nowMs - receivedAtMs) / 1000);
    return ttlSeconds - elapsedSeconds;
};
